(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    const DAY_MS = 86400000;
    const DEFAULT_TIME_ZONE = 'America/Chicago';
    const DEFAULT_WORKING_DAYS = [1, 2, 3, 4, 5];
    const DATE_PARTS = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    };

    const boundedInteger = (value, minimum, maximum, fallback) => {
      const parsed = Number.parseInt(value, 10);
      return Number.isInteger(parsed) && parsed >= minimum && parsed <= maximum ? parsed : fallback;
    };

    const normalizeTimeZone = (timeZone) => {
      try {
        new Intl.DateTimeFormat('en-US', { timeZone }).format();
        return timeZone;
      } catch (error) {
        return DEFAULT_TIME_ZONE;
      }
    };

    const normalizeConfig = (config = {}) => {
      const workingDays = Array.from(
        new Set(
          Array.isArray(config.workingDays)
            ? config.workingDays
                .map((day) => Number.parseInt(day, 10))
                .filter((day) => Number.isInteger(day) && day >= 0 && day <= 6)
            : []
        )
      );
      const dayMode = ['min_only', 'both', 'none'].includes(config.dayMode)
        ? config.dayMode
        : 'min_only';

      return {
        timeZone: normalizeTimeZone(config.timeZone || DEFAULT_TIME_ZONE),
        workingDays: workingDays.length ? workingDays : DEFAULT_WORKING_DAYS,
        minDays: boundedInteger(config.minDays, 0, 365, 1),
        maxDays: boundedInteger(config.maxDays, 0, 365, 2),
        dayMode,
        cutoffHour: boundedInteger(config.cutoffHour, 0, 23, 14),
        cutoffMinute: boundedInteger(config.cutoffMinute, 0, 59, 0),
        cutoffBump: boundedInteger(config.cutoffBump, 0, 30, 1),
      };
    };

    const getZonedParts = (date, timeZone) => {
      const formatter = new Intl.DateTimeFormat('en-US-u-nu-latn', {
        ...DATE_PARTS,
        timeZone,
      });
      const parts = {};
      formatter.formatToParts(date).forEach(({ type, value }) => {
        if (type !== 'literal') parts[type] = Number.parseInt(value, 10);
      });
      return parts;
    };

    const partsToOrdinal = ({ year, month, day }) => Date.UTC(year, month - 1, day);

    const ordinalToParts = (ordinal) => {
      const date = new Date(ordinal);
      return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),
      };
    };

    const ordinalToIso = (ordinal) => {
      const { year, month, day } = ordinalToParts(ordinal);
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    };

    const addDays = (ordinal, days, workingDays, useWorkingDays) => {
      if (!useWorkingDays) return ordinal + days * DAY_MS;

      const allowedDays = new Set(workingDays);
      let result = ordinal;
      let remaining = days;
      let guard = 0;

      while (remaining > 0 && guard < 3700) {
        result += DAY_MS;
        if (allowedDays.has(new Date(result).getUTCDay())) remaining -= 1;
        guard += 1;
      }

      return result;
    };

    const getTimeZoneOffset = (date, timeZone) => {
      const parts = getZonedParts(date, timeZone);
      const wallClock = Date.UTC(
        parts.year,
        parts.month - 1,
        parts.day,
        parts.hour,
        parts.minute,
        parts.second
      );
      const instant = Math.floor(date.getTime() / 1000) * 1000;
      return wallClock - instant;
    };

    const zonedDateTimeToDate = (parts, timeZone) => {
      const wallClock = Date.UTC(
        parts.year,
        parts.month - 1,
        parts.day,
        parts.hour,
        parts.minute,
        parts.second || 0
      );
      let instant = wallClock;

      for (let attempt = 0; attempt < 4; attempt += 1) {
        const nextInstant = wallClock - getTimeZoneOffset(new Date(instant), timeZone);
        if (Math.abs(nextInstant - instant) < 1000) {
          instant = nextInstant;
          break;
        }
        instant = nextInstant;
      }

      return new Date(instant);
    };

    const calculateEstimate = (now = new Date(), rawConfig = {}) => {
      const config = normalizeConfig(rawConfig);
      const local = getZonedParts(now, config.timeZone);
      const localOrdinal = partsToOrdinal(local);
      const currentMinute = local.hour * 60 + local.minute;
      const cutoffMinute = config.cutoffHour * 60 + config.cutoffMinute;
      const afterCutoff = currentMinute >= cutoffMinute;
      const cutoffAdjustment = afterCutoff ? config.cutoffBump : 0;
      const minimumUsesWorkingDays = config.dayMode === 'min_only' || config.dayMode === 'both';
      const maximumUsesWorkingDays = config.dayMode === 'both';
      const minimumOrdinal = addDays(
        localOrdinal,
        config.minDays + cutoffAdjustment,
        config.workingDays,
        minimumUsesWorkingDays
      );
      const maximumOrdinal = addDays(
        localOrdinal,
        config.maxDays + cutoffAdjustment,
        config.workingDays,
        maximumUsesWorkingDays
      );
      const promisedOrdinal = Math.max(minimumOrdinal, maximumOrdinal);
      const cutoffOrdinal = localOrdinal + (afterCutoff ? DAY_MS : 0);
      const cutoffDate = ordinalToParts(cutoffOrdinal);
      const cutoffInstant = zonedDateTimeToDate(
        {
          ...cutoffDate,
          hour: config.cutoffHour,
          minute: config.cutoffMinute,
          second: 0,
        },
        config.timeZone
      );
      const countdownMinutes = Math.max(
        0,
        Math.ceil((cutoffInstant.getTime() - now.getTime()) / 60000)
      );

      return {
        timeZone: config.timeZone,
        afterCutoff,
        minimumDate: ordinalToIso(minimumOrdinal),
        maximumDate: ordinalToIso(maximumOrdinal),
        promisedDate: ordinalToIso(promisedOrdinal),
        promisedOrdinal,
        countdownMinutes,
      };
    };

    const formatDate = (ordinal, locale = 'en-US') =>
      new Intl.DateTimeFormat(locale, {
        timeZone: 'UTC',
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      }).format(new Date(ordinal));

    const formatCountdown = (totalMinutes, labels) => {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      const hourLabel = hours === 1 ? labels.hourOne : labels.hourOther;
      const minuteLabel = minutes === 1 ? labels.minuteOne : labels.minuteOther;
      return `${hours} ${hourLabel} ${minutes} ${minuteLabel}`;
    };

    const core = Object.freeze({
      calculateEstimate,
      formatCountdown,
      formatDate,
      normalizeConfig,
    });

    globalThis.PlugDeliveryEstimateCore = core;

    if (
      typeof customElements === 'undefined' ||
      typeof HTMLElement === 'undefined' ||
      typeof document === 'undefined' ||
      customElements.get('plug-delivery-estimate')
    ) {
      return;
    }

    const instances = new Set();
    let refreshTimer;

    const renderAll = () => {
      const now = new Date();
      instances.forEach((instance) => instance.render(now));
    };

    const scheduleRefresh = () => {
      window.clearTimeout(refreshTimer);
      if (!instances.size) return;
      const delay = 60000 - (Date.now() % 60000) + 50;
      refreshTimer = window.setTimeout(() => {
        renderAll();
        scheduleRefresh();
      }, delay);
    };

    class PlugDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        instances.add(this);
        this.render();
        scheduleRefresh();
      }

      disconnectedCallback() {
        instances.delete(this);
        scheduleRefresh();
      }

      getConfig() {
        const workingDayNames = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ];
        const workingDays = workingDayNames
          .map((name, day) => (this.dataset[`working${name}`] === 'true' ? day : null))
          .filter((day) => day !== null);

        return {
          timeZone: this.dataset.timeZone,
          workingDays,
          minDays: this.dataset.minDays,
          maxDays: this.dataset.maxDays,
          dayMode: this.dataset.dayMode,
          cutoffHour: this.dataset.cutoffHour,
          cutoffMinute: this.dataset.cutoffMinute,
          cutoffBump: this.dataset.cutoffBump,
        };
      }

      render(now = new Date()) {
        if (this.dataset.enabled !== 'true' || this.dataset.available === 'false') {
          this.hidden = true;
          return;
        }

        try {
          const estimate = core.calculateEstimate(now, this.getConfig());
          const dateTarget = this.querySelector('[data-delivery-estimate-date]');
          const countdownTarget = this.querySelector('[data-delivery-estimate-countdown]');
          const countdownWrapper = this.querySelector('[data-delivery-estimate-countdown-wrapper]');
          const showCountdown = this.dataset.showCountdown === 'true';

          dateTarget.textContent = core.formatDate(
            estimate.promisedOrdinal,
            this.dataset.locale || 'en-US'
          );
          countdownTarget.textContent = core.formatCountdown(estimate.countdownMinutes, {
            hourOne: this.dataset.hourOne,
            hourOther: this.dataset.hourOther,
            minuteOne: this.dataset.minuteOne,
            minuteOther: this.dataset.minuteOther,
          });
          countdownWrapper.hidden = !showCountdown;
          this.hidden = false;
        } catch (error) {
          this.hidden = true;
        }
      }
    }

    customElements.define('plug-delivery-estimate', PlugDeliveryEstimate);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        renderAll();
        scheduleRefresh();
      }
    });

    const bindVariantUpdates = () => {
      if (
        globalThis.PlugDeliveryEstimateVariantBound ||
        typeof subscribe !== 'function' ||
        typeof PUB_SUB_EVENTS === 'undefined'
      ) {
        return;
      }

      globalThis.PlugDeliveryEstimateVariantBound = true;
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const available = event?.data?.variant?.available;
        const sectionId = event?.data?.sectionId;
        if (typeof available !== 'boolean') return;
        instances.forEach((instance) => {
          if (sectionId && instance.dataset.sectionId !== String(sectionId)) return;
          instance.dataset.available = String(available);
          instance.render();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindVariantUpdates, { once: true });
    } else {
      bindVariantUpdates();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["first-phone-afterpay"] && !Shopify.designMode) return;
  try {
    if (!document.querySelector('script[src="https://js.squarecdn.com/square-marketplace.js"]')) {
    const script = document.createElement('script');
    script.src = 'https://js.squarecdn.com/square-marketplace.js';
    script.async = true;
    document.head.append(script);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["first-phone-shell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('first-phone-content')) {
    customElements.define(
      'first-phone-content',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.origin =
            new URL(location.href).searchParams.get('plug_content_origin') === 'first-phone'
              ? 'first-phone'
              : 'direct';
          if (this.dataset.fpSurface === 'hub') this.origin = 'first-phone';
          this.onConsent = () => {
            try {
              if (!this.allowed()) sessionStorage.removeItem('plug_first_phone_origin');
            } catch (_) {}
          };
          document.addEventListener('visitorConsentCollected', this.onConsent);
          this.addEventListener('click', (event) => {
            const print = event.target.closest('[data-fp-print]');
            if (print) {
              this.capture('first_phone_print_clicked', { kind: 'print' });
              window.print();
              return;
            }
            const link = event.target.closest('a[href]');
            if (!link) return;
            const destination = new URL(link.href, location.origin);
            const card = link.closest('[data-product-id]');
            const kind = link.dataset.fpKind || (card ? 'product' : 'guide');
            if (
              destination.origin === location.origin &&
              destination.pathname !== location.pathname
            ) {
              destination.searchParams.set('plug_content_origin', 'first-phone');
              link.href = destination.href;
            }
            this.capture('first_phone_link_clicked', {
              kind,
              destination_path: destination.pathname,
              placement:
                link.closest('[data-fp-placement]')?.dataset.fpPlacement || this.dataset.fpSurface,
              product_id: card?.dataset.productId,
              variant_id: card?.dataset.variantId,
            });
          });
          if (!document.querySelector('first-phone-content[data-fp-viewed]')) {
            this.dataset.fpViewed = 'true';
            this.capture('first_phone_content_viewed', {});
          }
        }
        disconnectedCallback() {
          document.removeEventListener('visitorConsentCollected', this.onConsent);
        }
        allowed() {
          try {
            return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
          } catch (_) {
            return false;
          }
        }
        capture(name, properties) {
          if (!this.allowed()) return;
          try {
            if (this.origin === 'first-phone')
              sessionStorage.setItem('plug_first_phone_origin', 'first-phone');
            else if (sessionStorage.getItem('plug_first_phone_origin') === 'first-phone')
              this.origin = 'first-phone';
          } catch (_) {}
          window.posthog?.capture?.(name, {
            hub_id: 'first-phone',
            source_path: location.pathname,
            entry_origin: this.origin,
            ...properties,
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["first-phone-tools"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fpToolsReady) return;
    window.__fpToolsReady = true;
    const t = (key, fallback) => (window.fpToolsStrings && window.fpToolsStrings[key]) || fallback;
    const track = (name, props) => {
      const host = document.querySelector('first-phone-content');
      if (host && typeof host.capture === 'function') host.capture(name, props || {});
    };
    const store = {
      get(key) {
        try {
          return JSON.parse(localStorage.getItem(key) || 'null');
        } catch (_) {
          return null;
        }
      },
      set(key, value) {
        try {
          localStorage.setItem(key, JSON.stringify(value));
        } catch (_) {}
      },
    };
    const money = (n) => '$' + Math.round(n).toLocaleString('en-US');

    function enhanceChecklists() {
      const lists = document.querySelectorAll('.fp-article .rte ul.fp-checklist');
      lists.forEach((list, listIndex) => {
        if (list.closest('.fp-check')) return;
        const key = 'fp_check:' + location.pathname + ':' + listIndex;
        const saved = store.get(key) || {};
        const wrap = document.createElement('div');
        wrap.className = 'fp-check';
        wrap.innerHTML =
          '<div class="fp-check__head"><span class="fp-check__count" data-fp-count></span>' +
          '<button type="button" class="fp-check__reset" data-fp-reset>' +
          t('reset', 'Clear checklist') +
          '</button></div>' +
          '<div class="fp-check__bar" aria-hidden="true"><div class="fp-check__fill" data-fp-fill></div></div>';
        list.parentNode.insertBefore(wrap, list);
        wrap.appendChild(list);
        const done = document.createElement('p');
        done.className = 'fp-check__done';
        done.textContent = t(
          'done',
          'All set. Save this page or download the PDF to keep it with your agreement.'
        );
        wrap.appendChild(done);
        const items = [...list.querySelectorAll(':scope > li')];
        items.forEach((li, i) => {
          const label = document.createElement('label');
          const box = document.createElement('input');
          box.type = 'checkbox';
          box.checked = !!saved[i];
          const text = document.createElement('span');
          while (li.firstChild) text.appendChild(li.firstChild);
          label.appendChild(box);
          label.appendChild(text);
          li.appendChild(label);
          box.addEventListener('change', () => {
            saved[i] = box.checked;
            store.set(key, saved);
            update(true);
          });
        });
        const count = wrap.querySelector('[data-fp-count]');
        const fill = wrap.querySelector('[data-fp-fill]');
        function update(fromUser) {
          const checked = items.filter((li) => li.querySelector('input').checked).length;
          count.textContent =
            checked + ' ' + t('of', 'of') + ' ' + items.length + ' ' + t('doneLabel', 'done');
          fill.style.width = Math.round((checked / items.length) * 100) + '%';
          const complete = checked === items.length && items.length > 0;
          wrap.classList.toggle('is-complete', complete);
          if (fromUser) {
            track('first_phone_checklist_progress', {
              checked,
              total: items.length,
              complete,
              list_index: listIndex,
            });
          }
        }
        wrap.querySelector('[data-fp-reset]').addEventListener('click', () => {
          items.forEach((li, i) => {
            li.querySelector('input').checked = false;
            saved[i] = false;
          });
          store.set(key, saved);
          update(true);
        });
        update(false);
      });
    }

    function enhanceAgeSections() {
      const body = document.querySelector('.fp-article .rte');
      if (!body) return;
      const heads = [...body.querySelectorAll('h3')].filter((h) =>
        /Ages?\s*1[03]/i.test(h.textContent)
      );
      if (heads.length < 2) return;
      const groups = heads.map((h) => {
        const section = document.createElement('div');
        section.className = 'fp-age-section';
        section.dataset.fpAge = /13/.test(h.textContent) ? '13' : '10';
        h.parentNode.insertBefore(section, h);
        let node = h;
        while (node && !(node.nodeType === 1 && /^H[23]$/.test(node.tagName) && node !== h)) {
          const next = node.nextSibling;
          section.appendChild(node);
          node = next;
        }
        return section;
      });
      const bar = document.createElement('div');
      bar.className = 'fp-age fp-no-print';
      bar.innerHTML =
        '<span class="fp-age__label">' +
        t('ageLabel', 'Show steps for') +
        '</span>' +
        '<button type="button" class="fp-seg" data-fp-age-pick="10">' +
        t('age10', 'Ages 10 to 12') +
        '</button>' +
        '<button type="button" class="fp-seg" data-fp-age-pick="13">' +
        t('age13', 'Ages 13 to 14') +
        '</button>' +
        '<button type="button" class="fp-seg" data-fp-age-pick="all">' +
        t('ageAll', 'Both') +
        '</button>';
      groups[0].parentNode.insertBefore(bar, groups[0]);
      const apply = (pick, fromUser) => {
        groups.forEach((g) => (g.hidden = pick !== 'all' && g.dataset.fpAge !== pick));
        bar
          .querySelectorAll('[data-fp-age-pick]')
          .forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.fpAgePick === pick)));
        store.set('fp_age', pick);
        if (fromUser) track('first_phone_age_selected', { age_band: pick });
      };
      bar.addEventListener('click', (e) => {
        const b = e.target.closest('[data-fp-age-pick]');
        if (b) apply(b.dataset.fpAgePick, true);
      });
      apply(store.get('fp_age') || 'all', false);
    }

    function initQuiz(quiz) {
      const questions = [...quiz.querySelectorAll('[data-fp-q]')];
      const results = [...quiz.querySelectorAll('[data-fp-result]')];
      const progress = quiz.querySelector('[data-fp-quiz-progress]');
      const actions = quiz.querySelector('[data-fp-quiz-actions]');
      const answers = {};
      const render = () => {
        const answered = Object.keys(answers).length;
        if (answered < questions.length) {
          results.forEach((r) => r.removeAttribute('data-active'));
          if (progress) {
            progress.hidden = false;
            progress.textContent =
              answered +
              ' ' +
              t('of', 'of') +
              ' ' +
              questions.length +
              ' ' +
              t('answered', 'answered');
          }
          return;
        }
        const score = Object.values(answers).reduce((a, b) => a + b, 0);
        const band = score >= 8 ? 'ready' : score >= 4 ? 'almost' : 'wait';
        results.forEach((r) => {
          if (r.dataset.fpResult === band) r.setAttribute('data-active', '');
          else r.removeAttribute('data-active');
        });
        if (progress) progress.hidden = true;
        if (actions) actions.hidden = false;
        track('first_phone_quiz_completed', { score, band });
      };
      quiz.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-fp-score]');
        if (btn) {
          const q = btn.closest('[data-fp-q]');
          q.querySelectorAll('[data-fp-score]').forEach((b) =>
            b.setAttribute('aria-pressed', 'false')
          );
          btn.setAttribute('aria-pressed', 'true');
          answers[q.dataset.fpQ] = Number(btn.dataset.fpScore);
          render();
        }
        if (e.target.closest('[data-fp-quiz-reset]')) {
          Object.keys(answers).forEach((k) => delete answers[k]);
          quiz
            .querySelectorAll('[data-fp-score]')
            .forEach((b) => b.setAttribute('aria-pressed', 'false'));
          if (actions) actions.hidden = true;
          render();
        }
      });
      render();
    }

    function initCalc(calc) {
      const phone = calc.querySelector('[data-fp-calc-phone]');
      const acc = calc.querySelector('[data-fp-calc-acc]');
      const line = calc.querySelector('[data-fp-calc-line]');
      const outLine = calc.querySelector('[data-fp-calc-out-line]');
      const outLineNote = calc.querySelector('[data-fp-calc-out-line-note]');
      const outBoost = calc.querySelector('[data-fp-calc-out-boost]');
      const outBoostNote = calc.querySelector('[data-fp-calc-out-boost-note]');
      let months = 12;
      // Months of Boost Mobile service a Connected Pack includes.
      const packMonths = 3;
      const num = (el) => Math.max(0, Number(el.value) || 0);
      const render = () => {
        const device = num(phone) + num(acc);
        const lineTotal = device + num(line) * months;
        const boostTotal = device + 25 * Math.max(0, months - packMonths);
        outLine.textContent = money(lineTotal);
        outLineNote.textContent =
          money(device) +
          ' ' +
          t('device', 'device and accessories') +
          ' + ' +
          money(num(line)) +
          ' x ' +
          months +
          ' ' +
          t('months', 'months');
        outBoost.textContent = money(boostTotal);
        outBoostNote.textContent =
          money(device) +
          ' ' +
          t('device', 'device and accessories') +
          ' + $25 x ' +
          (months - packMonths) +
          ' ' +
          t('months', 'months') +
          ' ' +
          t('boostFirst', '(3 months included with an eligible Connected Pack)');
      };
      calc.addEventListener('input', render);
      calc.addEventListener('click', (e) => {
        const b = e.target.closest('[data-fp-calc-months]');
        if (!b) return;
        months = Number(b.dataset.fpCalcMonths);
        calc
          .querySelectorAll('[data-fp-calc-months]')
          .forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        render();
        track('first_phone_calculator_used', { months });
      });
      let tracked = false;
      calc.addEventListener('input', () => {
        if (!tracked) {
          tracked = true;
          track('first_phone_calculator_used', { months });
        }
      });
      render();
    }

    function initAppCheck(box) {
      const rows = [...box.querySelectorAll('.fp-appcheck__row')];
      const verdicts = [...box.querySelectorAll('[data-fp-app-verdict]')];
      const answers = {};
      box.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-fp-app]');
        if (!btn) return;
        const row = btn.closest('.fp-appcheck__row');
        row
          .querySelectorAll('[data-fp-app]')
          .forEach((b) => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        answers[rows.indexOf(row)] = Number(btn.dataset.fpApp);
        if (Object.keys(answers).length < rows.length) return;
        const yes = Object.values(answers).reduce((a, b) => a + b, 0);
        const band = yes === rows.length ? 'add' : yes >= 3 ? 'ask' : 'skip';
        verdicts.forEach((v) => {
          if (v.dataset.fpAppVerdict === band) v.setAttribute('data-active', '');
          else v.removeAttribute('data-active');
        });
        track('first_phone_appcheck_completed', { yes, band });
      });
    }

    function initDownloads() {
      document.addEventListener('click', (e) => {
        const a = e.target.closest('[data-fp-download]');
        if (a) track('first_phone_download_clicked', { file: a.dataset.fpDownload });
      });
    }

    let booted = false;
    const boot = () => {
      if (booted) return;
      booted = true;
      enhanceChecklists();
      enhanceAgeSections();
      document.querySelectorAll('[data-fp-quiz]').forEach(initQuiz);
      document.querySelectorAll('[data-fp-calc]').forEach(initCalc);
      document.querySelectorAll('[data-fp-appcheck]').forEach(initAppCheck);
      initDownloads();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-featured-tech"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('header-featured-tech')) {
    customElements.define(
      'header-featured-tech',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.editor = Boolean(window.Shopify?.designMode);
          this.drawer = this.closest('details');
          this.impressed = new Set();
          this.slots ||= this.collectSlots();
          if (this.slots.length && !this.selection) this.selectProducts();
          this.addEventListener(
            'click',
            (event) => {
              const card = event.target.closest('[data-featured-product]');
              if (!card) return;
              this.capture('featured_tech_click', this.values(card));
            },
            options
          );
          this.drawer?.addEventListener('toggle', () => this.measure(), options);
          document.addEventListener('visitorConsentCollected', () => this.measure(), options);
          this.observer = new MutationObserver(() => this.measure());
          if (this.drawer)
            this.observer.observe(this.drawer, {
              subtree: true,
              attributes: true,
              attributeFilter: ['open', 'class'],
            });
          if (typeof IntersectionObserver !== 'undefined') {
            this.intersection = new IntersectionObserver(
              ([entry]) => {
                this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
                this.measure();
              },
              { threshold: [0, 0.5] }
            );
            this.intersection.observe(this);
          }
          if (!this.slots.length && this.dataset.sectionUrl) this.scheduleLoad(options);
        }

        collectSlots() {
          return Array.from(this.querySelectorAll('[data-featured-slot]'), (element) => ({
            element,
            name: element.dataset.featuredSlot,
            cards: [
              element.querySelector(':scope > a'),
              ...Array.from(element.querySelectorAll('template'), (template) =>
                template.content.querySelector('a')
              ),
            ].filter(Boolean),
          }));
        }

        scheduleLoad(options) {
          const load = () => this.load();
          const summary = this.drawer?.querySelector(':scope > summary');
          for (const type of ['pointerenter', 'pointerdown', 'touchstart', 'focus'])
            summary?.addEventListener(type, load, { ...options, once: true, passive: true });
          this.drawer?.addEventListener('toggle', load, { ...options, once: true });
          // Prefetch only where the menu button is shown; desktop uses the inline menu instead.
          const prefetch = () => {
            if (summary?.getClientRects().length) load();
          };
          const idle = () =>
            window.requestIdleCallback
              ? window.requestIdleCallback(prefetch, { timeout: 4000 })
              : setTimeout(prefetch, 2000);
          if (document.readyState === 'complete') idle();
          else window.addEventListener('load', idle, { ...options, once: true });
        }

        load() {
          if (this.editor || !this.dataset.sectionUrl) return Promise.resolve();
          this.loading ||= this.fetchSlots()
            .then((html) => this.hydrate(html))
            .catch((error) => {
              this.hidden = true;
              this.reportFailure(error);
            });
          return this.loading;
        }

        cacheKey() {
          return `${this.dataset.storageKey}_panel_${this.dataset.sectionUrl}`;
        }

        async fetchSlots() {
          try {
            const cached = JSON.parse(sessionStorage.getItem(this.cacheKey()));
            const age = Date.now() - cached?.savedAt;
            if (typeof cached?.html === 'string' && age >= 0 && age < 600000) return cached.html;
          } catch {}
          const response = await fetch(this.dataset.sectionUrl, { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`Featured tech failed to load: ${response.status}`);
          const html = Array.from(
            new DOMParser()
              .parseFromString(await response.text(), 'text/html')
              .querySelectorAll('[data-featured-slot]'),
            (slot) => slot.outerHTML
          ).join('');
          try {
            sessionStorage.setItem(this.cacheKey(), JSON.stringify({ savedAt: Date.now(), html }));
          } catch {}
          return html;
        }

        hydrate(html) {
          const container = this.querySelector('.featured-tech__slots');
          container.innerHTML = html;
          container.setAttribute('aria-busy', 'false');
          this.slots = this.collectSlots();
          if (!this.slots.length) {
            this.hidden = true;
            return;
          }
          this.selectProducts();
          this.measure();
        }

        selectProducts() {
          let previous;
          if (!this.editor) {
            try {
              previous = JSON.parse(sessionStorage.getItem(this.dataset.storageKey));
            } catch {}
          }
          this.selection = {};
          for (const slot of this.slots) {
            const alternatives = this.editor
              ? slot.cards
              : slot.cards.filter(
                  (card) => card.dataset.featuredProduct !== previous?.products?.[slot.name]
                );
            const candidates = alternatives.length ? alternatives : slot.cards;
            const categories = [
              ...new Set(candidates.map((card) => card.dataset.featuredCategory)),
            ];
            const category =
              categories[this.editor ? 0 : Math.floor(Math.random() * categories.length)];
            const pool = candidates.filter((card) => card.dataset.featuredCategory === category);
            const selected = pool[this.editor ? 0 : Math.floor(Math.random() * pool.length)];
            if (!selected) continue;
            const current = slot.element.querySelector(':scope > a');
            if (current !== selected) current.replaceWith(selected.cloneNode(true));
            this.selection[slot.name] = selected.dataset.featuredProduct;
          }
          if (!this.editor) {
            try {
              sessionStorage.setItem(
                this.dataset.storageKey,
                JSON.stringify({ products: this.selection })
              );
            } catch {}
          }
        }

        values(card) {
          return {
            product_id: card.dataset.featuredProduct,
            category: card.dataset.featuredCategory,
            slot: card.closest('[data-featured-slot]').dataset.featuredSlot,
            destination: card.getAttribute('href'),
          };
        }

        // PostHog only: a failed panel would otherwise show up only as missing impressions. It
        // stays out of the dataLayer so GTM tags never see a non-shopper event.
        reportFailure(error) {
          try {
            if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
            window.posthog?.capture?.('featured_tech_load_failed', {
              featured_tech_release: 'featured-tech-v1',
              reason: String(error?.message || error).slice(0, 120),
            });
          } catch {}
        }

        capture(event, values) {
          try {
            if (
              this.editor ||
              this.dataset.measure !== 'true' ||
              window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true
            )
              return false;
          } catch {
            return false;
          }
          const payload = { event, featured_tech_release: 'featured-tech-v1', ...values };
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(payload);
          } catch {}
          try {
            window.posthog?.capture?.(event, payload);
          } catch {}
          return true;
        }

        measure() {
          if (
            !this.slots?.length ||
            !this.inView ||
            document.hidden ||
            !this.drawer?.open ||
            this.drawer.querySelector('.submenu-open')
          )
            return;
          if (!this.menuMeasured && this.capture('featured_tech_menu_view', {}))
            this.menuMeasured = true;
          for (const slot of this.slots) {
            const card = slot.element.querySelector(':scope > a');
            if (
              !this.impressed.has(slot.name) &&
              this.capture('featured_tech_impression', this.values(card))
            )
              this.impressed.add(slot.name);
          }
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.observer?.disconnect();
          this.intersection?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
